var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-select", {
    ref: "select",
    class: {
      vSelectMultiple: _vm.multiple && !_vm.hasCheckboxes,
      vsSelectedCheckboxes: _vm.hasCheckboxes || _vm.referrersCheckboxes,
    },
    attrs: {
      placeholder: _vm.placeholder,
      label: _vm.label,
      options:
        _vm.scenario === "documents" ||
        _vm.scenario === "lenderProduct" ||
        _vm.scenario === "board" ||
        _vm.scenario === "agents" ||
        _vm.scenario === "reports"
          ? _vm.options
          : _vm.optionsToUse,
      clearable: _vm.clearable,
      "deselect-from-dropdown": _vm.deselectFromDropdown,
      filterable: _vm.filterable,
      disabled: _vm.disabled || _vm.loading,
      loading: _vm.loading,
      "dropdown-should-open": _vm.dropdownShouldOpen,
      value: _vm.value || _vm.model,
      components: { Deselect: _vm.Deselect },
      multiple: _vm.multiple,
      "close-on-select": _vm.multiple ? false : true,
      auto: true,
      autoscroll: _vm.autoscroll,
    },
    on: {
      open: _vm.handleOpen,
      "option:selected": _vm.handleSelect,
      "option:deselected": _vm.handleDeselect,
      close: _vm.handleClose,
      search: _vm.handleSearch,
    },
    scopedSlots: _vm._u([
      {
        key: "spinner",
        fn: function (ref) {
          var loading = ref.loading
          return [loading ? _c("inline-loader") : _vm._e()]
        },
      },
      {
        key: "list-header",
        fn: function () {
          return [
            !_vm.noOptionsText && _vm.scenario === "documents"
              ? _c(
                  "li",
                  {
                    staticClass: "vs__dropdown-option",
                    on: { click: _vm.selectAll },
                  },
                  [
                    _c("div", { staticClass: "w-100" }, [
                      _c("div", { staticClass: "row no-gutters pt-0" }, [
                        _c("div", { staticClass: "d-flex flex-column" }, [
                          _c(
                            "div",
                            { staticClass: "pretty p-icon p-smooth mb-3" },
                            [
                              _c("input", {
                                staticClass: "form-check-input",
                                attrs: {
                                  id: "select-all-docs",
                                  type: "checkbox",
                                },
                                domProps: { checked: _vm.isChecked("all") },
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "state p-primary mb-2" },
                                [
                                  _c("i", { staticClass: "icon fa fa-check" }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "pl-5",
                                      attrs: { for: "select-all-docs" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.$tc("global.words.all", 1)
                                          ) +
                                          "\n                "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                  ]
                )
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "no-options",
        fn: function () {
          return [
            _vm.noOptionsText && !_vm.loadingOptions
              ? _c("span", [
                  _vm._v("\n      " + _vm._s(_vm.noOptionsText) + "\n    "),
                ])
              : _vm.loadingOptions
              ? _c(
                  "span",
                  [
                    _vm.scenario == "documents"
                      ? _c("inline-loader")
                      : _vm._e(),
                  ],
                  1
                )
              : _c("span", [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("global.phrases.noResultsFound")) +
                      "\n    "
                  ),
                ]),
          ]
        },
        proxy: true,
      },
      {
        key: "list-footer",
        fn: function () {
          return [
            !(
              _vm.scenario === "simple" ||
              _vm.scenario === "reports" ||
              _vm.hasCheckboxes
            )
              ? _c(
                  "span",
                  {
                    style: {
                      visibility: _vm.loadingOptions ? "visible" : "hidden",
                    },
                  },
                  [
                    _c(
                      "li",
                      {
                        ref: "loader",
                        staticClass: "d-flex flex-row justify-content-center",
                      },
                      [
                        _c("b-skeleton", {
                          attrs: {
                            animation: "fade",
                            width: "90%",
                            height: "0.5rem",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                )
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "option",
        fn: function (option) {
          return [
            _vm.scenario === "cobrokering"
              ? _c("div", [
                  _c("span", [_vm._v(_vm._s(option.brokerageName) + " ")]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.scenario === "referrers"
              ? _c("div", { staticClass: "w-100 px-3" }, [
                  _c(
                    "div",
                    { staticClass: "row no-gutters align-items-center" },
                    [
                      _vm.referrersCheckboxes
                        ? _c(
                            "div",
                            {
                              staticClass: "pretty p-icon p-smooth mb-3 mt-1",
                              staticStyle: {
                                display: "flex",
                                "align-items": "center",
                                "margin-right": "8px",
                              },
                            },
                            [
                              _c("input", {
                                staticClass: "form-check-input",
                                attrs: {
                                  id: option.id + "-id",
                                  type: "checkbox",
                                },
                                domProps: { checked: _vm.isChecked(option.id) },
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "state p-primary mb-2",
                                  staticStyle: {
                                    display: "inline-flex",
                                    "align-items": "center",
                                  },
                                },
                                [
                                  _c("i", { staticClass: "icon fa fa-check" }),
                                  _vm._v(" "),
                                  _c("label", {
                                    staticClass: "mb-0",
                                    attrs: { for: option.id + "-id" },
                                  }),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col text-left text-truncate" },
                        [
                          _c("span", { staticClass: "bold" }, [
                            _vm._v(_vm._s(_vm._f("fullName")(option)) + " "),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "text-truncate" }, [
                            _c("span", [
                              _vm._v(
                                _vm._s(option.email ? option.email : " --") +
                                  " "
                              ),
                            ]),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col text-right text-truncate" },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                option.phoneNumber ? option.phoneNumber : " --"
                              ) + " "
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "row no-gutters" }, [
                    option.type
                      ? _c(
                          "div",
                          { staticClass: "col text-right text-truncate" },
                          [
                            _c("span", { staticClass: "tiny-font" }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(option.type) +
                                  "\n          "
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ])
              : _vm.scenario === "agents"
              ? _c("div", { staticClass: "w-100 form-page agents" }, [
                  _c("div", { staticClass: "row no-gutters pt-0" }, [
                    _vm.hasCheckboxes
                      ? _c(
                          "div",
                          {
                            staticClass: "pretty p-icon p-smooth mb-3 mt-1",
                            staticStyle: { display: "flex" },
                          },
                          [
                            _c("input", {
                              staticClass: "form-check-input",
                              attrs: {
                                id: option.id + "-id",
                                type: "checkbox",
                              },
                              domProps: { checked: _vm.isChecked(option.id) },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "state p-primary mb-2",
                                staticStyle: {
                                  display: "inline-flex",
                                  "align-self": "center",
                                },
                              },
                              [
                                _c("i", { staticClass: "icon fa fa-check" }),
                                _vm._v(" "),
                                _c("label", {
                                  attrs: { for: option.id + "-id" },
                                }),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "d-flex flex-column" }, [
                      _c("div", { staticClass: "pretty p-icon p-smooth" }, [
                        _c(
                          "div",
                          {
                            staticClass: "state p-primary",
                            staticStyle: {
                              display: "inline-flex",
                              "align-self": "center",
                            },
                          },
                          [
                            _c(
                              "div",
                              [
                                _c(
                                  "profile-avatar",
                                  _vm._b(
                                    {
                                      staticClass: "client-avatar mr-3 ml-3",
                                      staticStyle: {
                                        width: "25px",
                                        height: "25px",
                                      },
                                      style:
                                        option.id === "all"
                                          ? { opacity: "0" }
                                          : {},
                                      attrs: {
                                        "avatar-initials":
                                          _vm.avatarInitials(option),
                                      },
                                    },
                                    "profile-avatar",
                                    option,
                                    false
                                  )
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", [
                              _c("div", [_vm._v(_vm._s(option.fullName))]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  _vm._s(option.email ? option.email : " --")
                                ),
                              ]),
                            ]),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                ])
              : (_vm.scenario === "simple" ||
                  _vm.scenario === "lenderName" ||
                  _vm.scenario === "reports") &&
                !_vm.multiple
              ? _c("div", { staticClass: "w-100 px-3" }, [
                  _c("div", { staticClass: "row no-gutters" }, [
                    _c("div", { staticClass: "col-8 text-left" }, [
                      _c("span", [_vm._v(_vm._s(option.text || option.label))]),
                    ]),
                  ]),
                ])
              : _vm.scenario === "lenderProduct"
              ? _c("div", { staticClass: "w-100 px-3" }, [
                  _c("div", { staticClass: "row no-gutters" }, [
                    _c("div", { staticClass: "col-8 text-left" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.lenderProductValue(option))),
                      ]),
                    ]),
                  ]),
                ])
              : _vm.scenario === "documents"
              ? _c("div", { staticClass: "w-100" }, [
                  _c("div", { staticClass: "row no-gutters pt-0" }, [
                    _c("div", { staticClass: "d-flex flex-column" }, [
                      _c(
                        "div",
                        { staticClass: "pretty p-icon p-smooth mb-3" },
                        [
                          _c("input", {
                            staticClass: "form-check-input",
                            attrs: { id: option.id + "-id", type: "checkbox" },
                            domProps: { checked: _vm.isChecked(option.id) },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "state p-primary mb-2" }, [
                            _c("i", { staticClass: "icon fa fa-check" }),
                            _vm._v(" "),
                            _c("label", { attrs: { for: option.id + "-id" } }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(option.label) +
                                  "\n              "
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                ])
              : _vm.hasCheckboxes
              ? _c("div", { staticClass: "w-100 multiple" }, [
                  _c("div", { staticClass: "row no-gutters pt-0" }, [
                    _c("div", { staticClass: "d-flex flex-column" }, [
                      _c("div", { staticClass: "pretty p-icon p-smooth" }, [
                        _c("input", {
                          staticClass: "form-check-input",
                          attrs: { id: option.id + "-id", type: "checkbox" },
                          domProps: { checked: _vm.isChecked(option.id) },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "state p-primary" }, [
                          _c("i", { staticClass: "icon fa fa-check" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "pl-5",
                              attrs: { for: option.id + "-id" },
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(option[_vm.label]) +
                                  "\n              "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                ])
              : _vm.scenario === "board"
              ? _c("div", { staticClass: "pb-0" }, [
                  _c("div", { staticClass: "row no-gutters pt-0" }, [
                    _c("div", { staticClass: "d-flex flex-column" }, [
                      _c("div", { staticClass: "bold" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(option.label) +
                            "\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(_vm._s(option.numberOfClients + " Clients")),
                      ]),
                    ]),
                  ]),
                ])
              : _vm._e(),
          ]
        },
      },
    ]),
    model: {
      value: _vm.model,
      callback: function ($$v) {
        _vm.model = $$v
      },
      expression: "model",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }